import {ClientReportInfo} from "./domain";
import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "../pagination";

export type ParentCaseAuthorizationListAction =
    | { type: 'SET_SELECTED'; selectedAuthorizationGuid: string | null }
    | { type: 'SET_SELECTED_AND_SHOW_MODAL'; selectedAuthorizationGuid: string | null }
    | { type: 'SHOW_MODAL'; }
    | { type: 'SHOW_NEW_REPORT_MODAL'; }
    | { type: 'HIDE_NEW_REPORT_MODAL'; }
    | { type: 'SHOW_VIEW_REPORT_MODAL'; selectedReport: ClientReportInfo | null }
    | { type: 'HIDE_VIEW_REPORT_MODAL'; }
    | { type: 'HIDE_MODAL'; }
    | { type: 'SET_SERVICE_TYPE_FILTER', serviceType: string }
    | { type: 'SET_AUTH_TYPE_FILTER', authType: string }
    | { type: 'SET_STATUS_FILTER', status: string }
    | { type: 'SET_SEARCH', search: string }
    | { type: 'SET_AUTH_MODAL_TAB_INDEX', index: number }
    | RelayPaginationActionPayload;


export interface ParentCaseAuthorizationListState {
    showModal: boolean;
    showViewReportModal: boolean;
    showNewReportModal: boolean;
    selectedReport: ClientReportInfo | null;
    selectedAuthorizationGuid: string | null;
    pagination: RelayPaginationState;
    serviceTypeFilter: string;
    authTypeFilter: string;
    statusFilter: string;
    searchFilter: string;
    authModalTabIndex: number;
}

export function initState(authorizationGuid: string | null, tabIndex: string | null): ParentCaseAuthorizationListState {
    return {
        showModal: authorizationGuid != null,
        showViewReportModal: false,
        showNewReportModal: false,
        selectedAuthorizationGuid: authorizationGuid,
        selectedReport: null,
        statusFilter: "",
        serviceTypeFilter: "",
        authTypeFilter: "",
        pagination: new RelayPaginationState('0', 8),
        searchFilter: "",
        authModalTabIndex: tabIndex && !isNaN(parseInt(tabIndex)) ? parseInt(tabIndex) : 0,
    };
}

export function parentCaseAuthorizationReducer(
    state: ParentCaseAuthorizationListState,
    action: ParentCaseAuthorizationListAction
): ParentCaseAuthorizationListState {
    switch (action.type) {
        case 'SET_SELECTED':
            return {
                ...state,
                selectedAuthorizationGuid: action.selectedAuthorizationGuid
            }
        case 'SHOW_MODAL':
            return {
                ...state,
                showModal: true
            }
        case 'HIDE_MODAL':
            return {
                ...state,
                showModal: false
            }
        case 'SET_SELECTED_AND_SHOW_MODAL':
            return {
                ...state,
                selectedAuthorizationGuid: action.selectedAuthorizationGuid,
                showModal: true
            }
        case 'SHOW_NEW_REPORT_MODAL':
            return {
                ...state,
                showNewReportModal: true,
            }
        case 'HIDE_NEW_REPORT_MODAL':
            return {
                ...state,
                showNewReportModal: false
            }
        case 'SHOW_VIEW_REPORT_MODAL':
            return {
                ...state,
                showViewReportModal: true,
                selectedReport: action.selectedReport,
            }
        case 'HIDE_VIEW_REPORT_MODAL':
            return {
                ...state,
                showViewReportModal: false,
                selectedReport: null
            }
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_STATUS_FILTER':
            return {
                ...state,
                statusFilter: action.status,
                pagination: new RelayPaginationState('0', 8),
            };
        case 'SET_SERVICE_TYPE_FILTER':
            return {
                ...state,
                serviceTypeFilter: action.serviceType,
                pagination: new RelayPaginationState('0', 8),
            };
        case 'SET_AUTH_TYPE_FILTER':
            return {
                ...state,
                authTypeFilter: action.authType,
                pagination: new RelayPaginationState('0', 8),
            };
        case 'SET_SEARCH':
            return {
                ...state,
                searchFilter: action.search,
                pagination: new RelayPaginationState('0', 8),
            };
        case 'SET_AUTH_MODAL_TAB_INDEX':
            return {
                ...state,
                authModalTabIndex: action.index
            };
        default:
            return state;
    }
}
